module.exports = __webpack_public_path__ + "img/twelfth-man-asset.de599093.png";